const { GET_EXPS, PAGE_ERROR, CLEAR_PAGE } = require("../types");

const INITIAL_STATE = {
  loadedExps: null,
  error: null,
  expsCountry: null,
  expsCount: null,
  loading: true,
}


const expsByCountryReducer = (state=INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch(type) {
    case GET_EXPS: 
      return {
        ...state, 
        loadedExps: payload.exps,
        expsCountry: payload.exps[0].expCountry,
        expsCount: payload.exps.length,
        loading: false
      }
    case PAGE_ERROR: 
      return {
        ...state,
        loadedExps: payload.exps,
        error: payload.err.message,
        expsCountry: null,
        expsCount: null,
        loading: false
      }
    case CLEAR_PAGE: 
      return {
        ...state,
        loadedExps: null,
        error: null,
        expsCountry: null,
        expsCount: null,
        loading: true,
      }
    default:
      return state;
  }
  
}


export default expsByCountryReducer;